import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSberIdLogoSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.8722 6.56426C15.9574 7.0327 16 7.51331 16 8C16 12.4167 12.4228 16 8 16C3.58327 16 0 12.4167 0 8C0 3.58327 3.58327 0 8 0C9.90418 0 11.6502 0.663118 13.0251 1.77034L11.4677 2.92015C10.4821 2.24487 9.28365 1.84943 8 1.84943C4.61141 1.84943 1.84943 4.60532 1.84943 8C1.84943 11.3947 4.61141 14.1506 8 14.1506C11.3886 14.1506 14.1506 11.3947 14.1506 8V7.83574L15.8722 6.56426ZM15.2943 4.6966C15.0327 4.13082 14.7103 3.59546 14.3331 3.10876L8.0061 7.77493L4.95819 5.86466V8.1582L8.0061 10.0685L15.2943 4.6966Z"
	})
});
export default SvgSberIdLogoSmall;
